module.exports = __webpack_public_path__ + "img/good.98ccc778.png";